import { selectBadge } from "@faire/retailer-visitor-shared/components/ProductBadge/badgeUtils";
import { handleShowroomProductBadgeViewed } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomBadgeUtils";
import { useProductTileClickImpressionContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressionContext";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";
import { IBadgeList } from "@faire/web-api--source/indigofair/badges/IBadgeList";

export const useRecordProductBadgeViewEvent = (
  token: string | undefined,
  badgeList: IBadgeList | undefined
) => {
  const { requestId, badgeEventTokens } =
    useProductTileClickImpressionContext();
  return useEffectEvent(() => {
    if (badgeEventTokens.has(token ?? "")) {
      return;
    }
    const topLeftTileBadge = selectBadge(badgeList?.badges ?? [], "TOP");
    handleShowroomProductBadgeViewed(token ?? "", requestId, topLeftTileBadge);
    badgeEventTokens.add(token ?? "");
  });
};
